import type { AdminGroup3 } from 'src/models/group3';

export interface AdminGroup3Response {
  id: number;
  parent_id: number | null;
  name: string;
  disp_order: number | null;
}

export type AdminGroup3IndexResponse = AdminGroup3Response[];

export const toAdminGroup3 = (response: AdminGroup3Response): AdminGroup3 => ({
  id: response.id,
  parentId: response.parent_id,
  name: response.name,
  dispOrder: response.disp_order,
});
